<template>
  <div class="registration">
    <div class="title-section">
      <h1 class="page-title">{{ $props.pageTitle }}</h1>
      <p class="page-subtitle">{{ $props.pageSubtitle }}</p>
    </div>
    <reset-password-form></reset-password-form>
  </div>
</template>

<script>
import ResetPasswordForm from '@/components/login/reset-password-form'
export default {
  name: 'page-user-reset-password',
  components: { ResetPasswordForm },
  props: {
    pageTitle: String,
    pageSubtitle: String
  }
}
</script>

<style scoped lang="scss">

</style>
